import React, {useEffect, useState} from "react";
import {BasicProps} from "../Main";
import {Grid} from "@mui/material";
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiButton} from "../Components/SamaggiButton";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {handleError} from "../support";
import {BaseButton} from "../Components/SSOButton";

export const SSODebug: React.FC<BasicProps> = (props) => {
    const [tokenReady, setTokenReady] = useState(false);
    const [tokenAvailable, setTokenAvailable] = useState(false);
    const [url, setURL] = useState("");
    const [image, setImage] = useState("https://general-assets-ss.s3.eu-west-2.amazonaws.com/logo_no_text_orange.png");
    const [cToken, setCToken] = useState("");
    const [tokenHidden, setTokenHidden] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        props.setShowCover(true);
        load() // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function load() {
        props.setShowCover(true);

        const token = localStorage.getItem("token");

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/sso/debug-token", {
            "token": token
        }).then((res) => {
            console.log(res);
            props.setShowCover(false);
            setTokenReady(true);

            if (res.data.data.debugTokenAvailable === true) {
                setTokenAvailable(true);
                if (token !== null) {
                    setCToken(token);
                }
            } else {
                setURL(res.data.data.requestURL);
            }
        }).catch((error) => {
            props.setShowCover(false);
            handleError(error, true);
        })
    }

    function onHover() {
        setImage("https://general-assets-ss.s3.eu-west-2.amazonaws.com/logo_no_text_white.png")
    }

    function onStopHover() {
        setImage("https://general-assets-ss.s3.eu-west-2.amazonaws.com/logo_no_text_orange.png")
    }


    return (
        <>
            <Grid container direction={"column"} spacing={3}>
                <Grid item container direction={"column"} spacing={2}>
                    <Grid item container direction={"column"} spacing={3}>
                        <Grid item>
                            <SamaggiTypography center xlarge bold>Request SamaggiSSO Debug Token</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center small bold colour={Colours.red}>STOP! Only continue if you know exactly what you're doing. The token that will be shown will allow ANYONE to access your account information. DO NOT send this to anyone. If you have been instructed to come here by someone other than the CIO, go back NOW.</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center small>This page will allow you to generate a token that has access to all personal information. This is for internal testing purposes only. Once you have granted permission on the new window, reload this page.</SamaggiTypography>
                        </Grid>
                    </Grid>
                </Grid>
                {tokenReady && (
                    <Grid item container direction={"column"} spacing={2}>
                        <Grid item>
                            {!tokenAvailable && <BaseButton fullWidth onMouseOver={onHover} onMouseOut={onStopHover} onClick={() => {window.open(url, "_blank")}}>
                                <Grid container direction={"row"}>
                                    <Grid item container direction={"row"} style={{
                                        backgroundImage: `url(${image})`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center'
                                    }} xs={1}>
                                    </Grid>
                                    <Grid item xs={11}>
                                        Grant Debug Permissions
                                    </Grid>
                                </Grid>
                            </BaseButton>}
                            {tokenAvailable && (
                                <SamaggiTypography center bold maxWidth={"100%"} sx={{ wordBreak: "break-word" }} noWrap={false}>
                                    {tokenHidden ? "<Token Hidden>" : cToken}
                                </SamaggiTypography>
                            )}
                        </Grid>
                        <Grid item container direction={"column"} spacing={1}>
                            {tokenAvailable && (
                                <Grid item>
                                    <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => {setTokenHidden(!tokenHidden)}}>{tokenHidden ? "Show Token": "Hide Token"}</SamaggiButton>
                                </Grid>
                            )}
                            {tokenAvailable && (
                                <Grid item>
                                    <SamaggiButton fullWidth>Copy to Clipboard</SamaggiButton>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                )}
                <Grid item>
                    <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => {navigate("/")}}>Back to Staff Portal</SamaggiButton>
                </Grid>
            </Grid>

        </>
    )

}